module.exports = __webpack_public_path__ + "media/images/e-bilet/directions/odesa-kyiv-f627f0f5ffe54186d01955e267fb4f3d.png";